import { useEffect, useState } from "react";

export default function UseBreakpoint(bp = 992) {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth < bp);

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < bp);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, [bp]);

    return isMobile;
}
